import { useEffect, useMemo, useState } from 'react'
import { authedAxios, debounce } from '../../utils'

const DEFAULT_PARAMS = { limit: 1000, offset: 0 }

const useCustomers = (queryString, params = {}) => {
  const [customers, setCustomers] = useState([])
  const [recent, setRecent] = useState([])

  const [isLoading, setIsLoading] = useState(true)
  const [hasLoadError, setHasLoadError] = useState(false)

  const getCustomers = (queryStringIn, paramsIn) => {
    const qs = queryStringIn || queryString

    const fullParams = { ...DEFAULT_PARAMS, ...(paramsIn || params) }

    setIsLoading(true)
    let url = '/api/customer'
    if (qs) url += `?query=${qs}`

    Object.keys(fullParams).forEach((key) => {
      const value = fullParams[key]
      if (!value) return
      const char = url.includes('?') ? '&' : '?'
      url += `${char}${key}=${value}`
    })

    return authedAxios
      .get(url)
      .then((res) => {
        setCustomers(res.data.customers)
        if (res.data.recent) {
          setRecent(res.data.recent)
        }
      })
      .catch((e) => {
        setHasLoadError(e)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const debouncedGetCustomers = useMemo(
    () =>
      debounce((queryString, params) => getCustomers(queryString, params), 200),
    []
  )

  useEffect(() => {
    setIsLoading(true)
    debouncedGetCustomers(queryString, params)
  }, [queryString, JSON.stringify(params)])

  return { customers, recent, isLoading, hasLoadError }
}

export default useCustomers
